<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      Are you sure you want to delete this page?
    </template>
    <template v-slot:body>
      <p class="secondary-text">
        This cannot be undone.
      </p>
    </template>
    <template v-slot:actions>
      <div class="cancel-booking-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <ErrorButton @click.native="handleSubmit" :loading="isLoading">
          Delete Page
        </ErrorButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { MICROSITE_NAMESPACE } from "@/store/modules/microsites";
import { DELETE_MICROSITE_PAGE } from "@/store/modules/microsites/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(MICROSITE_NAMESPACE);

export default {
  components: { ErrorButton, PrimaryButton, BaseDialog },
  props: {
    isOpen: Boolean,
    pageDetails: Object
  },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions({
      deletePage: DELETE_MICROSITE_PAGE
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.deletePage(this.pageDetails);
      this.$emit("close");
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.cancel-booking-description {
  min-height: 100px;
}
</style>
